import $http from 'devcude-common/src/utils/DcHttp';
import {stringify} from 'qs';
import DcResponse from 'devcude-common/src/models/DcResponse'
import type { AxiosRequestConfig } from 'axios'



export default class DictCompCommonApi {

    static  async  dictData(    config: AxiosRequestConfig = {}
  ):Promise<DcResponse> {
        const $_params = stringify(Object.assign({},
        ))


  const resp = await $http.post("/api/dictCompCommon/dictData",$_params,config);
  return resp;
  }

}